/**
 * @author: subhasish.ghosh@zoom.us
 */

import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import NoRecord from "@static/no_records.svg";

export const NoRecords = ({ refetchFunc, children }) => (
  <Box sx={{ position: "relative", top: "20px" }}>
    <IconButton
      size="large"
      aria-label="account of current user"
      aria-controls="menu-appbar"
      aria-haspopup="true"
      onClick={() => refetchFunc()}
      color="inherit"
    >
      <Tooltip title="Refresh">
        <img src={NoRecord} alt="Zoom Logo" className="nav-logo" />
      </Tooltip>
    </IconButton>
    {children}
  </Box>
);

export default NoRecords;
